import { Module, Action, getModule } from 'vuex-module-decorators';

import EntityBaseModule from '@/store/entity';
import store from '@/store';

import { getById, addNewEntity, updateEntity, removeEntity } from '@/api/crud';

import { transformPage, transformBackendPage } from './backend';

import { Pages } from '@/models/pages';
import { PageValues } from '@/types/models/pages';

export const MODULE_NAME = Pages.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class PagesEntityModule extends EntityBaseModule {

    @Action({ rawError: true })
    async getById(id: string) {
        try {
            const result = await getById(Pages.apiPrefix, id);
            const page = transformBackendPage(result);
    
            return page;
        } catch (clientError) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async create(data: PageValues) {
        const page = transformPage(data);

        return addNewEntity(Pages.apiPrefix, page);
    }

    @Action({ rawError: true })
    async update({ id, data }: {id: string; data: PageValues}) {
        const page = transformPage(data);

        return updateEntity(Pages.apiPrefix, id, page, '');
    }

    @Action({ rawError: true })
    async delete(id: string) {
        return removeEntity(Pages.apiPrefix, id);
    }
}

export default getModule(PagesEntityModule);